import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Cambió completamente cómo manejo las guardias. Antes dudaba con los lactantes febriles. Ahora tengo algoritmos claros, sé qué estudios pedir y cómo documentar todo para estar tranquilo.',
  author: 'Dra. Florencia M.',
  role: 'Pediatra de Guardia (CABA)'
}, {
  quote: 'El módulo de urgencias respiratorias es oro. Sé exactamente cuándo escalar el tratamiento en una crisis asmática y los criterios de internación son clarísimos. Me dio muchísima seguridad.',
  author: 'Dr. Sebastián R.',
  role: 'Pediatra en Hospital Público (Córdoba)'
}, {
  quote: 'Las plantillas legales y los scripts para hablar con padres a las 3 AM me salvaron de más de un problema. Ahora sé cómo manejar la presión y dejar todo asentado en la historia clínica.',
  author: 'Dra. Carolina P.',
  role: 'Pediatra (Rosario)'
}];
export function Testimonials() {
  return <section className="bg-slate-50 py-8 sm:py-28 border-t border-slate-200/60 overflow-hidden" data-id="element-347">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-348">
        <div className="text-center mb-5 sm:mb-16" data-id="element-349">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-teal-600 uppercase mb-1.5 sm:mb-3" data-id="element-350">
            +800 PROFESIONALES LO USAN
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-351">
            Lo que dicen los profesionales
          </p>
        </div>

        <div className="flex overflow-x-auto snap-x snap-mandatory gap-3 pb-4 -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-1 md:grid-cols-3 sm:gap-8 hide-scrollbar" data-id="element-352">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileTap={{
          scale: 0.98
        }} className="min-w-[85%] sm:min-w-0 snap-center bg-white rounded-xl sm:rounded-2xl p-5 sm:p-8 shadow-sm ring-1 ring-slate-200 relative flex flex-col" data-id="element-353">
              <Quote className="absolute top-4 right-4 sm:top-6 sm:right-6 w-5 h-5 sm:w-8 sm:h-8 text-blue-100" data-id="element-354" />
              <div className="flex text-amber-400 mb-3 sm:mb-6" data-id="element-355">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 sm:w-5 sm:h-5 fill-current" data-id="element-356" />)}
              </div>
              <p className="text-xs sm:text-base text-slate-700 leading-relaxed mb-4 sm:mb-8 flex-grow relative z-10" data-id="element-357">
                "{testimonial.quote}"
              </p>
              <div data-id="element-358">
                <p className="font-semibold text-slate-900 text-xs sm:text-base" data-id="element-359">
                  {testimonial.author}
                </p>
                <p className="text-[10px] sm:text-sm text-slate-500 mt-0.5 sm:mt-1" data-id="element-360">
                  {testimonial.role}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-1 sm:hidden text-[10px] font-medium text-slate-400 flex items-center justify-center gap-1.5" data-id="element-361">
          <span data-id="element-362">←</span> Deslizá para ver más <span data-id="element-363">→</span>
        </div>
      </div>
    </section>;
}